export const PRODUCTS = [
  {
    id: "vlp-110-38-wood",
    name: { tr: "VLP 110 Ahşap", en: "VLP 110 Wood" },
    finish: { tr: "Ahşap Seri", en: "Wood Series" },
    finishKey: "wood",
    dims: "110 × 60 × 38 cm",
    price: 2450,
    image:
      "https://images.unsplash.com/photo-1600422086908-72be2c8f5f3f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxtaW5pbWFsaXN0JTIwd29vZCUyMGNhYmluZXQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODczNTA1OTJ8MA&ixlib=rb-4.1.0&q=85",
    bestseller: true,
  },
  {
    id: "vlp-110-42-white",
    name: { tr: "VLP 110 Beyaz", en: "VLP 110 White" },
    finish: { tr: "Beyaz Seri", en: "White Series" },
    finishKey: "white",
    dims: "110 × 60 × 42 cm",
    price: 2350,
    image:
      "https://images.pexels.com/photos/8381834/pexels-photo-8381834.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    bestseller: false,
  },
  {
    id: "vlp-190-38-wood",
    name: { tr: "VLP 190 Ahşap", en: "VLP 190 Wood" },
    finish: { tr: "Ahşap Seri", en: "Wood Series" },
    finishKey: "wood",
    dims: "190 × 60 × 38 cm",
    price: 3450,
    image:
      "https://images.unsplash.com/photo-1784651859318-d9300849bf34?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxtaW5pbWFsaXN0JTIwd29vZCUyMGNhYmluZXQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODczNTA1OTJ8MA&ixlib=rb-4.1.0&q=85",
    bestseller: false,
  },
  {
    id: "vlp-190-42-white",
    name: { tr: "VLP 190 Beyaz", en: "VLP 190 White" },
    finish: { tr: "Beyaz Seri", en: "White Series" },
    finishKey: "white",
    dims: "190 × 60 × 42 cm",
    price: 3350,
    image:
      "https://images.pexels.com/photos/8381834/pexels-photo-8381834.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    bestseller: false,
  },
  {
    id: "vlp-60-30-wood",
    name: { tr: "VLP 60 Ahşap", en: "VLP 60 Wood" },
    finish: { tr: "Ahşap Seri", en: "Wood Series" },
    finishKey: "wood",
    dims: "60 × 30 × 30 cm",
    price: 1450,
    image:
      "https://images.pexels.com/photos/36887750/pexels-photo-36887750.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    bestseller: false,
  },
  {
    id: "vlp-60-60-white",
    name: { tr: "VLP 60 Beyaz", en: "VLP 60 White" },
    finish: { tr: "Beyaz Seri", en: "White Series" },
    finishKey: "white",
    dims: "60 × 60 × 30 cm",
    price: 1650,
    image:
      "https://images.unsplash.com/photo-1600422086908-72be2c8f5f3f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxtaW5pbWFsaXN0JTIwd29vZCUyMGNhYmluZXQlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODczNTA1OTJ8MA&ixlib=rb-4.1.0&q=85",
    bestseller: false,
  },
];

export const formatPrice = (n) => `₺${n.toLocaleString("tr-TR")}`;
